import axios from 'axios';

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000';

export interface TestResult {
  id: string;
  test_date: string;
  raw_total_score: number;
  standardized_score: number;
  percentile: number;
  raw_category_scores: { [key: string]: number };
  ai_feedback?: string;
  survey_version: {
    survey_type: string;
    version: string;
  };
}

export interface ProgressTimeline {
  date: string;
  raw_score: number;
  standardized_score: number;
  percentile: number;
}

export interface CategoryTrend {
  category: string;
  data: Array<{
    date: string;
    score: number;
  }>;
}

export interface ProgressStatistics {
  averageScore: number;
  improvementRate: number;
  totalTests: number;
  currentPercentile?: number;
}

export interface ChildProgress {
  timeline: ProgressTimeline[];
  categoryTrends: CategoryTrend[];
  statistics: ProgressStatistics;
}

/**
 * 부모 자녀 관계 서비스
 */
class ParentChildService {
  /**
   * 자녀의 테스트 결과 조회
   */
  async getChildTestResults(childId: string): Promise<TestResult[]> {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found');
    }

    const response = await axios.get<{ success: boolean; data: TestResult[] }>(
      `${API_URL}/parent-child/children/${childId}/tests`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.data;
  }

  /**
   * 자녀의 테스트 진척도 조회
   */
  async getChildProgress(childId: string): Promise<ChildProgress> {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found');
    }

    const response = await axios.get<{ success: boolean; data: ChildProgress }>(
      `${API_URL}/parent-child/children/${childId}/progress`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.data;
  }
}

export default new ParentChildService();
